// extracted by mini-css-extract-plugin
module.exports = {"header":"TimeRangeBlock_header__1_hse"};